import { EventDialogTab } from '../../../../../features/live-events/hooks/useEventDialogTabs'

/**
 * URLs from the internal tools into the customer-facing Live Events Tracker.
 */

/** The game's calendar, grouped by blueprint. */
export const customerCalendarUrl = (gameId: string) => `/live-events-tracker/games?gameIds=${gameId}&groupByArchetype=true`

/**
 * The calendar with a blueprint's event dialog open.
 *
 * The modal has no blueprint id param of its own, so it is addressed through one of the blueprint's
 * events and that event's type. Without either, only the plain calendar can open.
 */
export const customerBlueprintUrl = ({ gameId, eventId, typeId }: { gameId: string; eventId?: string; typeId?: string }) =>
  eventId && typeId
    ? `${customerCalendarUrl(gameId)}&modalType=liveEventType&m_trackedGameId=${gameId}&m_liveEventTypeId=${typeId}&m_liveEventId=${eventId}&m_tab=${
        EventDialogTab.LiveEventEvolution
      }`
    : customerCalendarUrl(gameId)
